var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFriends(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "friends",
    d: "M12 2C6.579 2 2 6.579 2 12C2 17.421 6.579 22 12 22C17.421 22 22 17.421 22 12C22 6.579 17.421 2 12 2Z",
    fill: "#4F5E7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.333 12C11.8037 12 12.9997 10.804 12.9997 9.33335C12.9997 7.86269 11.8037 6.66669 10.333 6.66669C8.86234 6.66669 7.66634 7.86269 7.66634 9.33335C7.66634 10.804 8.86234 12 10.333 12ZM11.333 12.6667H9.33301C7.12701 12.6667 5.33301 14.4607 5.33301 16.6667V17.3334H15.333V16.6667C15.333 14.4607 13.539 12.6667 11.333 12.6667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0697 11.3653C15.4757 10.6734 15.6511 9.8702 15.5704 9.072C15.451 7.88267 14.787 6.83133 13.7017 6.112L12.965 7.22267C13.711 7.71733 14.165 8.422 14.2437 9.20533C14.28 9.5694 14.2347 9.93697 14.111 10.2813C13.9874 10.6257 13.7886 10.9381 13.529 11.196L12.7344 11.9907L13.813 12.3073C16.6344 13.134 16.667 15.9713 16.667 16H18.0004C18.0004 14.8073 17.363 12.4767 15.0697 11.3653Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFriends);
export default __webpack_public_path__ + "static/media/friends.7213e9e0a707b2a9789efbf91d6a1ada.svg";
export { ForwardRef as ReactComponent };